import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { splitGroupSentence } from "@/lib/turnoverWindow";

function guestInitial(name?: string | null): string {
  const first = (name || "").trim().split(/\s+/)[0];
  return first ? first[0]!.toUpperCase() : "?";
}

/** Slice 12b owner Schedule: 22px guest face beside each group sentence. */
function GuestFace({ photoUrl, name }: { photoUrl?: string | null; name?: string | null }) {
  return (
    <Avatar className="mt-px h-[22px] w-[22px] shrink-0 overflow-hidden bg-[#e7edf1] text-[10px] font-bold text-[#7d8c99]">
      {photoUrl ? (
        <AvatarImage src={photoUrl} alt="" className="object-cover" referrerPolicy="no-referrer" />
      ) : null}
      <AvatarFallback className="bg-[#e7edf1] text-[10px] font-bold text-[#7d8c99]">
        {guestInitial(name)}
      </AvatarFallback>
    </Avatar>
  );
}

export function OwnerGroupSentences({
  outSentence,
  inSentence,
  outGuestPhotoUrl,
  inGuestPhotoUrl,
  outGuestName,
  inGuestName,
  showFaces = false,
  className,
  size = "row",
}: {
  outSentence?: string | null;
  inSentence?: string | null;
  outGuestPhotoUrl?: string | null;
  inGuestPhotoUrl?: string | null;
  outGuestName?: string | null;
  inGuestName?: string | null;
  /** Slice 12b: guest faces only on owner Schedule (desktop + phone), not Assign/Overview. */
  showFaces?: boolean;
  className?: string;
  size?: "row" | "sheet";
}) {
  const lines = [
    outSentence?.trim()
      ? { sentence: outSentence.trim(), photo: outGuestPhotoUrl, name: outGuestName }
      : null,
    inSentence?.trim()
      ? { sentence: inSentence.trim(), photo: inGuestPhotoUrl, name: inGuestName }
      : null,
  ].filter((l): l is { sentence: string; photo?: string | null; name?: string | null } => Boolean(l));
  if (lines.length === 0) return null;
  const text = size === "sheet" ? "text-[14px] leading-[1.45]" : "text-[13.5px] leading-[1.45]";
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      {lines.map((line) => {
        const { lead, time } = splitGroupSentence(line.sentence);
        return (
          <div
            key={line.sentence}
            className={cn("flex items-start", showFaces ? "gap-2" : undefined)}
          >
            {showFaces ? <GuestFace photoUrl={line.photo} name={line.name} /> : null}
            <div className={cn(text, "min-w-0 font-medium text-[#64748b]")}>
              {lead}
              {time ? <span className="font-bold text-[#0f1720]">{time}</span> : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
